"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getOutline = getOutline;

var _url = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/url"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _pdfjsDist = require("pdfjs-dist");

var _files = require("./files");

function sortOutline(outline) {
  (0, _forEach.default)(outline).call(outline, function (item) {
    var _context;

    (0, _sort.default)(_context = item.subItems).call(_context, function (a, b) {
      return a.index - b.index;
    });
    sortOutline(item.subItems);
  });
}

var mapOutline = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(parentItem, document) {
    var outline;
    return _regenerator.default.wrap(function _callee2$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            outline = [];
            _context3.next = 3;
            return _promise.default.all((0, _map.default)(parentItem).call(parentItem, /*#__PURE__*/function () {
              var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(item, index) {
                var title, destArray, destObj, dest;
                return _regenerator.default.wrap(function _callee$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        title = item.title;

                        if (!(typeof item.dest === 'string')) {
                          _context2.next = 7;
                          break;
                        }

                        _context2.next = 4;
                        return document.getDestination(item.dest);

                      case 4:
                        destArray = _context2.sent;
                        _context2.next = 8;
                        break;

                      case 7:
                        destArray = item.dest;

                      case 8:
                        if (!(0, _isArray.default)(destArray)) {
                          _context2.next = 25;
                          break;
                        }

                        destObj = {
                          ref: destArray[0],
                          x: destArray[2],
                          y: destArray[3]
                        };
                        dest = encodeURIComponent((0, _stringify.default)(destObj));
                        _context2.t0 = outline;
                        _context2.t1 = index;
                        _context2.t2 = title;
                        _context2.t3 = dest;

                        if (!(item.items && item.items.length > 0)) {
                          _context2.next = 21;
                          break;
                        }

                        _context2.next = 18;
                        return mapOutline(item.items, document);

                      case 18:
                        _context2.t4 = _context2.sent;
                        _context2.next = 22;
                        break;

                      case 21:
                        _context2.t4 = [];

                      case 22:
                        _context2.t5 = _context2.t4;
                        _context2.t6 = {
                          index: _context2.t1,
                          title: _context2.t2,
                          dest: _context2.t3,
                          subItems: _context2.t5
                        };

                        _context2.t0.push.call(_context2.t0, _context2.t6);

                      case 25:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x3, _x4) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 3:
            sortOutline(outline);
            return _context3.abrupt("return", outline);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee2);
  }));

  return function mapOutline(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

function getOutline(_x5) {
  return _getOutline.apply(this, arguments);
}

function _getOutline() {
  _getOutline = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(document) {
    var password,
        doc,
        data,
        docOutline,
        outline,
        _args3 = arguments;
    return _regenerator.default.wrap(function _callee3$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            password = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : '';

            if (!(document instanceof Blob)) {
              _context4.next = 10;
              break;
            }

            _context4.next = 4;
            return (0, _files.readFile)(document);

          case 4:
            data = _context4.sent;
            _context4.next = 7;
            return (0, _pdfjsDist.getDocument)({
              data: data,
              password: password
            }).promise;

          case 7:
            doc = _context4.sent;
            _context4.next = 17;
            break;

          case 10:
            if (!(document instanceof _url.default && password)) {
              _context4.next = 16;
              break;
            }

            _context4.next = 13;
            return (0, _pdfjsDist.getDocument)({
              url: document,
              password: password
            }).promise;

          case 13:
            doc = _context4.sent;
            _context4.next = 17;
            break;

          case 16:
            doc = document;

          case 17:
            _context4.next = 19;
            return doc.getOutline();

          case 19:
            docOutline = _context4.sent;
            outline = [];

            if (!docOutline) {
              _context4.next = 25;
              break;
            }

            _context4.next = 24;
            return mapOutline(docOutline, doc);

          case 24:
            outline = _context4.sent;

          case 25:
            return _context4.abrupt("return", outline);

          case 26:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee3);
  }));
  return _getOutline.apply(this, arguments);
}
